import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { PreferredSupplierComponent } from './preferred-supplier.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  { path: '', component: PreferredSupplierComponent, data: { title: 'VME Preferred Suppliers' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PreferredSupplierRoutingModule {}

@NgModule({
  imports: [
    PreferredSupplierRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [PreferredSupplierComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PreferredSupplierModule {}
